import JwtDecode from 'jwt-decode';
import Cookie from 'js-cookie';
import { abreviaturas } from 'constantes';
// eslint-disable-next-line import/no-unresolved
import { UserManager } from 'oidc-client-ts';
import { AnalyticsAmplitud } from '../utils/Analytics-Amplitud';

class AuthService {
    /**
     * @name readingTokenDecode
     * @desc Metodo para decodificar el token y retornarlo para usar
     * @param token
     * @returns {any}
     */
    readingTokenDecode = (token) => JwtDecode(token);

    /**
     * @name initAmplitude
     * @desc Metodo para iniciar la conexión con analitics de amplitude
     */
    initAmplitude = (userName) => {
        AnalyticsAmplitud.instancieAmplitude(userName);
    };

    /**
     * @name storeSessionData
     * @desc Metodo para almacenas la sesion del usuario
     * @param sessionData
     */
    storeSessionData = (sessionData) => {
        let token = null;
        if (sessionData.t) {
            const { t } = sessionData || {};
            token = t;
        } else {
            const { tokenApp } = sessionData || {};
            token = tokenApp;
        }
        Cookie.set(abreviaturas.TYPE_TOKEN, token);
        Cookie.set(abreviaturas.INFOSESSION, JSON.stringify(sessionData));

        // Se decodifica token
        const decodeToken = this.readingTokenDecode(token);

        // iniciar amplitude
        this.initAmplitude(decodeToken.sidUsuario || '');
    };

    /**
     * @name isUserEquals
     * @desc Metodo que valida si el susuario loguedo es igual al entregado en el token
     * @param token
     * @param username
     * @returns {*|boolean}
     */
    isUserEquals = (token, username) => {
        try {
            const tokenObj = token ? this.readingTokenDecode(token) : null;

            return tokenObj && (
                tokenObj.email === username || tokenObj.preferred_username === username
            );
        } catch (e) {
            return false;
        }
    };

    /**
     * @name getToken
     * @desc Metodo que retorna el token
     * @returns {*}
     */
    getToken = () => Cookie.get(abreviaturas.TYPE_TOKEN);

    /**
     * @name getSessionInfo
     * @desc Metodo que retorna los valores de la sesion
     * @returns {any|null}
     */
    getSessionInfo = () => {
        const info = Cookie.get(abreviaturas.INFOSESSION);
        return info ? JSON.parse(info) : null;
    };

    /**
     * @name logoutKeycloack
     * @desc Metodo encargado de realizar el proceso de logout en el reino de
     * keycloaky repligue en app
     * @param settings
     */
    logoutKeycloack = (settings) => {
        try {
            const { settings: settingsObj } = JSON.parse(`${settings}`);
            const {
                authority, client_id: clientId, client_secret: clientSecret,
            } = settingsObj || {};

            // Objeto a instanciar
            const userManager = new UserManager({
                authority,
                client_id: clientId,
                client_secret: clientSecret,
                redirect_uri: `${window.location.origin}/apiv1/sign-in`,
                response_type: 'id_token token',
                scope: 'openid profile',
                post_logout_redirect_uri: `${window.location.origin}/apiv1/sign-in`,
            });

            // configuración de cierre de sesión
            const logoutRequest = {
                id_token_hint: '',
                login_hint: '',
                post_logout_redirect_uri: `${window.location.origin}/apiv1/sign-in`,
            };

            Cookie.set(abreviaturas.SETTINGS_OIDC, null);
            userManager.signoutRedirect(logoutRequest);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(`Error de logout: ${e}`);
        }
    }

    /**
     * @name logout
     * @desc Realiza el deslogueo del usuario
     */
    logout = () => {
        const settingsOidc = Cookie.get(abreviaturas.SETTINGS_OIDC);

        this.logoutKeycloack(settingsOidc);
        Cookie.set(abreviaturas.TYPE_TOKEN, null);
    };

    /**
     * @name isTokenValid
     * @desc Metodo que verifica el estado del token
     * @returns {boolean}
     */
    isTokenValid = () => {
        const token = this.getToken();
        // Capturo el id que viene en la ruta
        const solicitudId = window.location.pathname.split('/');
        if (solicitudId[3]) {
            Cookie.set(abreviaturas.DEFAULT_SOLICITUD_ID, solicitudId[3]);
        }

        if (token) {
            try {
                const decodeToken = this.readingTokenDecode(token);
                const now = Date.now().valueOf() / 1000;
                const expired = decodeToken.exp && decodeToken.exp < now;
                const inactive = (!decodeToken.iat || (decodeToken.nbf && decodeToken.iat >= now));
                // Se guarda nombre de usuario
                Cookie.set(abreviaturas.SIDUSUARIO, decodeToken.sidUsuario);
                return !(expired && inactive);
            } catch (e) {
                return false;
            }
        }
        return false;
    }
}

export default new AuthService();
